import { FC } from 'react';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { colors } from 'styles';

import { IHeaderSection } from 'types/articles';

import SaveLinkIcon from 'assets/common/icons/save-link.svg';
import BlackLinkedInIcon from 'assets/common/icons/black-linkedin.svg';
import { useIsMobile } from 'hooks/useIsMobile';

export const HeaderSection: FC<IHeaderSection> = ({
  resourceType,
  author,
  image,
  minutesOfRead,
  publishDate,
  text,
  title,
  linkedInAuthorLink,
  authorImage,
}) => {
  const isMobile = useIsMobile();

  const handleCopy = async () => {
    await navigator.clipboard.writeText('https://www.linkedin.com/company/ailivesim/');
  };

  return (
    <Box maxWidth="100%">
      <Typography
        color={colors.textPrimary}
        fontWeight={600}
        lineHeight="150%"
        marginBottom="16px"
        sx={{
          fontSize: '16px',
        }}
      >
        {resourceType}
      </Typography>

      <Typography
        color={colors.textPrimary}
        fontWeight={700}
        lineHeight="120%"
        marginBottom="24px"
        sx={{
          fontSize: {
            md: 44,
            sm: 32,
            xxs: 24,
          },
        }}
      >
        {title}
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        paddingBottom="24px"
        sx={{
          borderBottom: '1px solid rgba(205, 205, 205, 1)',
        }}
      >
        {(resourceType === 'Article' || resourceType === 'White Paper') && (
          <>
            <Box display="flex" alignItems="center">
              <Box
                marginRight="16px"
                borderRadius="50%"
                sx={{
                  height: {
                    sm: '48px',
                    xxs: '32px',
                  },
                  width: {
                    sm: '48px',
                    xxs: '32px',
                  },
                  cursor: 'pointer',
                }}
              >
                <img
                  src={authorImage}
                  alt="author"
                  style={{
                    width: '100%',
                    borderRadius: '50%',
                  }}
                />
              </Box>

              <Box
                sx={{
                  color: colors.textPrimary,
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight={600}
                  lineHeight="150%"
                  color={colors.textPrimary}
                  sx={{
                    textDecoration: 'none',
                  }}
                  component="a"
                  href={linkedInAuthorLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {author}
                </Typography>
                <Typography fontSize="14px" lineHeight="150%">
                  {publishDate} • {minutesOfRead} min read
                </Typography>
              </Box>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                flexDirection: {
                  xxs: 'column',
                  xs: 'row',
                },
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns={{
                  xxs: 'repeat(2, 32px)',
                  xs: 'repeat(2, 1fr)',
                }}
                mt={{ xxs: '16px', xs: '0' }}
              >
                <Box
                  onClick={() => {
                    handleCopy();
                  }}
                >
                  <img src={SaveLinkIcon} />
                </Box>

                <Box>
                  <a
                    href="https://www.linkedin.com/company/ailivesim"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={BlackLinkedInIcon} />
                  </a>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>

      {resourceType === 'White Paper' && image && (
        <Box
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: '100%',
            cursor: 'pointer',
            marginTop: '25px',
            marginBottom: '48px',
          }}
        >
          <img
            src={image}
            alt="header image"
            style={{
              width: '100%',
              display: 'block',
            }}
          />
        </Box>
      )}

      <Box margin="48px 0">
        {typeof text === 'string' ? (
          <div
            style={{
              fontSize: isMobile ? '16px' : '18px',
              lineHeight: isMobile ? '150%' : '140%',
              color: colors.textPrimary,
            }}
          >
            {text}
          </div>
        ) : (
          <div
            style={{
              fontSize: isMobile ? '16px' : '18px',
              lineHeight: isMobile ? '150%' : '140%',
              color: colors.textPrimary,
            }}
          >
            {text}
          </div>
        )}
      </Box>

      {resourceType !== 'White Paper' && image && (
        <Box
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: '100%',
            cursor: 'pointer',
          }}
        >
          <img
            src={image}
            alt="header image"
            style={{
              width: '100%',
              display: 'block',
            }}
          />
        </Box>
      )}
    </Box>
  );
};
